<template>
  <vg-view-field
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
      :value="value | datetimeHoursMinutes"
  />
</template>

<script>
import VgViewField from "@/components/Commons/VgViewField.vue";

export default {
  name: "DateField",
  components: {VgViewField},
  props: {
    label: String,
    value: String,
  }
}
</script>

<style scoped>

</style>